import { actionTypes } from '../actioncreators/actioncreators'

let initialState = {
  key: undefined
}

export const JiraReducer = (currentState = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOAD_JIRA_ISSUE_KEY:
      return Object.assign({}, currentState, { key: action.key })
    default:
      return currentState
  }
}

export default JiraReducer
